import RequestAbstract from '../abstract';

export default class MerchantTerminalBalances extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-merchant-terminal-balances';
    }
}
